import {
  MantineThemeOverride,
  MultiSelect,
  Paper,
  Pill,
  Select,
} from '@mantine/core';

const theme: MantineThemeOverride = {
  fontFamily: 'Manrope, sans-serif',

  headings: {
    fontFamily: 'Manrope, sans-serif',
  },

  black: '#444',

  colors: {
    brand: [
      '#CCEFE5',
      '#AAE2D1',
      '#88D1BC',
      '#66BFA6',
      '#44A98F',
      '#229176',
      '#00765b',
      '#006E51',
      '#005E43',
      '#004731',
    ],
  },

  primaryColor: 'brand',

  cursorType: 'pointer',

  components: {
    Pill: Pill.extend({
      styles: {
        root: {
          backgroundColor: '#229176',
          color: '#fff',
        },
      },
    }),
    Paper: Paper.extend({
      defaultProps: { radius: '20px' },
    }),
    Select: Select.extend({
      defaultProps: {
        scrollAreaProps: {
          type: 'auto',
          scrollbarSize: 6,
        },
      },
    }),
    MultiSelect: MultiSelect.extend({
      defaultProps: {
        scrollAreaProps: {
          type: 'auto',
          scrollbarSize: 6,
        },
      },
    }),
  },
};

export default theme;
